// Entorno TEST: usa APIs de prueba (apigretest)
export const environment = {
    production: false,
    apiUrl: 'https://apigretest.apinfocore.com',
    apiGreconductores: 'https://apigretest.apinfocore.com',
    apiUrlAdmin: 'https://admin.api.apinfocore.com',
    apiUrlVivir: 'https://vivir.apinfocore.com',
    apiUrlSat: 'https://sat.apinfocore.com',
    apiUrlSunat: 'https://sunat.apinfocore.com',
    apiUrlReniec: 'https://reniec.apinfocore.com',
    apiUrlOsiptel: 'https://osiptel-dot-prod-api-322101.uc.r.appspot.com',
    apiUrlApiPlaca: 'https://apiplaca-dot-prod-api-322101.uc.r.appspot.com',
    apiUrlPlaca: 'https://placa.apinfocore.com',
    apiUrlFirma: 'https://data-dot-prod-api-322101.uc.r.appspot.com',
    apiUrlMasivo: 'https://masivo-dot-desa-api.uc.r.appspot.com',
    apiUrlSunarp: 'https://sunarp-dot-prod-api-322101.uc.r.appspot.com',
    apiUrlWhatsapp: 'https://proceso-whatsapp-dot-prod-api-322101.uc.r.appspot.com',
    apiUrlDemo: 'https://demo-dot-prod-api-322101.uc.r.appspot.com/',
    apiUrlSBS: 'https://api-sbs-dot-prod-api-322101.uc.r.appspot.com',
    apiUrlEssalud: 'https://api-essalud-dot-prod-api-322101.uc.r.appspot.com',
    apiUrlAdmin2: 'https://apii-invitaaqui-dot-lavafast-d4a16.uc.r.appspot.com',
    apiUrlbackground: 'http://localhost:8081',
	apiUrlLocal: 'https://apigretest.apinfocore.com/api',
    apiUrlGreManual: 'https://apigretest.apinfocore.com/api',
    path: 'https://apipadron.apinfocore.com',
    path2: 'https://api.infoweb.app',
    path3: 'https://apipadron.apinfocore.com',
    path4: 'https://admin.apinfocore.com',
    apiUrlSunarp2: 'https://sunarp.apinfocore.com',
    apiUrlApiPlaca2: 'https://apiplaca.apinfocore.com',
    webUrl: 'https://webgretest.apinfocore.com',
};
